/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodConnectionActivityStateDto } from './PaymentMethodConnectionActivityStateDto';
import {
    PaymentMethodConnectionActivityStateDtoFromJSON,
    PaymentMethodConnectionActivityStateDtoFromJSONTyped,
    PaymentMethodConnectionActivityStateDtoToJSON,
    PaymentMethodConnectionActivityStateDtoToJSONTyped,
} from './PaymentMethodConnectionActivityStateDto';

/**
 * 
 * @export
 * @interface PaymentMethodLocationDto
 */
export interface PaymentMethodLocationDto {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodLocationDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodLocationDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodLocationDto
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodLocationDto
     */
    locationName: string;
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof PaymentMethodLocationDto
     */
    enabledInApps: Set<FavritApp>;
    /**
     * 
     * @type {PaymentMethodConnectionActivityStateDto}
     * @memberof PaymentMethodLocationDto
     */
    activityState: PaymentMethodConnectionActivityStateDto;
}



/**
 * Check if a given object implements the PaymentMethodLocationDto interface.
 */
export function instanceOfPaymentMethodLocationDto(value: object): value is PaymentMethodLocationDto {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('enabledInApps' in value) || value['enabledInApps'] === undefined) return false;
    if (!('activityState' in value) || value['activityState'] === undefined) return false;
    return true;
}

export function PaymentMethodLocationDtoFromJSON(json: any): PaymentMethodLocationDto {
    return PaymentMethodLocationDtoFromJSONTyped(json, false);
}

export function PaymentMethodLocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodLocationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'locationId': json['locationId'],
        'locationName': json['locationName'],
        'enabledInApps': (new Set((json['enabledInApps'] as Array<any>).map(FavritAppFromJSON))),
        'activityState': PaymentMethodConnectionActivityStateDtoFromJSON(json['activityState']),
    };
}

export function PaymentMethodLocationDtoToJSON(json: any): PaymentMethodLocationDto {
    return PaymentMethodLocationDtoToJSONTyped(json, false);
}

export function PaymentMethodLocationDtoToJSONTyped(value?: PaymentMethodLocationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'locationId': value['locationId'],
        'locationName': value['locationName'],
        'enabledInApps': (Array.from(value['enabledInApps'] as Set<any>).map(FavritAppToJSON)),
        'activityState': PaymentMethodConnectionActivityStateDtoToJSON(value['activityState']),
    };
}

